import { accountBadgeStatuses } from '@juvare/badging/backend/features/badges/entities/AccountBadgeEntityTypes';
import { extendedAddressSchema } from '@juvare/credentialing/backend/features/person-credentials/entities/types';
import { shiftAttendanceStatuses } from '@juvare/missions/backend/extraTypes';
import { TypedPlatformFunctionDef } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions/shared';
import { z } from 'zod';

const getCheckInModalDataParamsSchema = z.object({
    accountBadgeNumber: z.string().trim().min(1),
    missionId: z.string().uuid().optional(),
    shiftId: z.string().uuid().optional(),
});

export type GetCheckInModalDataParams = z.infer<typeof getCheckInModalDataParamsSchema>;

const getCheckInModalDataResponseSchema = z.object({
    accountId: z.string().uuid(),
    accountDisplayName: z.string().trim().min(1),
    gender: z.string().optional(),
    dateOfBirth: z.string().optional(),
    address: extendedAddressSchema.optional(),
    missionName: z.string().trim().min(1),
    shiftStartDate: z.number(),
    shiftEndDate: z.number(),
    shiftParticipantId: z.string().uuid(),
    shiftCounty: z.string().trim().min(1),
    shiftCheckInTime: z.number().optional(),
    shiftCheckOutTime: z.number().optional(),
    shiftCheckInDuration: z.number().optional(),
    shiftAttendanceStatus: z.enum(shiftAttendanceStatuses).optional(),
    accountBadgeOrganization: z.string().optional(),
    accountBadgeOccupation: z.string().optional(),
    accountBadgeExpirationDate: z.number(),
    accountBadgeStatus: z.enum(accountBadgeStatuses),
    badgeTitle: z.string().trim().min(1),
});

export type GetCheckInModalDataResponse = z.infer<typeof getCheckInModalDataResponseSchema>;

export const getCheckInModalDataFunctionDef = {
    name: 'getCheckInModalData',
    requestSchema: getCheckInModalDataParamsSchema,
    responseSchema: getCheckInModalDataResponseSchema,
} satisfies TypedPlatformFunctionDef;
